import axios from 'axios';
import appSettings from '../../appSettings';
import { logInfo, logError } from '../utilities/AppInsightsUtil';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

// In order to reduce code complexity, common functionality can be separated into a special function specifically for calling the service and returning the data/error
const makeServiceCall = async ({ eventName, url, method = 'GET', token, extraHeaders, params = {}, data = {}, useProxy = false  }) => {
    try {
        logInfo(SeverityLevel.Information, eventName, url);
        const fullUrl = useProxy ? `${appSettings.AGSS_PROXY_BASE_URL}${url}` : `${appSettings.AMOD_AMS_EXPERIENCE_API}${url}`
        
        const headers = {
            'Ocp-Apim-Subscription-Key': appSettings.AMOD_AMS_EXPERIENCE_API_SUBSCRIPTION_KEY,
            ...extraHeaders
        };

        if (token) {
            headers.Authorization = `Bearer ${token}`;
        }

        const config = {
            url: fullUrl,
            method: method,
            headers: headers
        };

        if (method === 'GET' || method === 'DELETE') {
            config.params = params;
        } else {
            config.data = data;
        }

        const response = await axios(config);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const logGenericError = (url, eventName, error, skipThrow) => {
    const genericError = `Error Event: ${eventName} - Description: An error occurred - Error Code: 500 - Error Description: ${error}`;
    logError(genericError, SeverityLevel.Error, url);
    if(skipThrow) {
        throw new Error(genericError);
    }
}

export { makeServiceCall, logGenericError }